import React, { useEffect, useState, useRef  } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import settings from '../config/settings';
import axios from "axios";
import {
  CForm,
  CInputGroup,
  CHeader,
  CToggler,
  CHeaderBrand,
  CInput,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CSubheader,
  CBreadcrumbRouter,
  CLink,
  CCol,
  CButton,
  CRow,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,

} from '@coreui/react'
import { CImg } from '@coreui/react'
import { Link, useHistory } from 'react-router-dom'
import { Tooltip  } from '@mui/material';
// import SimpleImageSlider from "react-simple-image-slider";
import DocumentDetails from '../views/details/DocumentDetails'
// routes config
import routes from '../routes'
import "./header.css"

import {
  TheHeaderDropdown,
  TheHeaderDropdownMssg,
  TheHeaderDropdownNotif,
  TheHeaderDropdownTasks
} from './index'
import { SportsRugbySharp } from '@material-ui/icons';
import { Grid, Stack } from '@mui/material';
import zIndex from '@material-ui/core/styles/zIndex';
import { handleApiError } from '../session/session-expire';

const useStyles = makeStyles(theme => ({

  // header_bg: {
  //   background: "rgb(131,73,191)",
  //   background: "linear-gradient(-90deg, rgba(131,73,191,1) 16%, rgba(25,229,246,1) 84%)",
  //   width: "100%",
  //   display: "table",
  //   position: "fixed",
  //   zIndex: "0",
  //   height: "130px",
  //   top: "0",
  //   "@media (max-width: 1200px)": {
  //     height: "230px",
  //   },
  //   "@media (max-width: 767px)": {
  //     height: "260px",
  //   }
  // },

  header_icon: {
    width: "200px",
    display: "block",
    position: "absolute",
    bottom: "10px",
    right: "10px",
    "@media (max-width: 767px)": {
      marginTop: "0",
    }
  },
  back_icon: {
    position: "absolute",
    left: "30px",
    bottom: "12px",
    "@media (max-width: 1200px)": {
      bottom: "25px"
    },

  },
  // header_bg1: {
  //   background: "rgb(131,73,191)",
  //   background: "linear-gradient(-90deg, rgba(131,73,191,1) 16%, rgba(25,229,246,1) 84%)",
  //   zIndex: "20",
  //   border: "0",
  //   paddingRight: "20px",
  //   paddingBottom: "15px",
  //   position: "fixed",
  //   display: 'flex',
  //   top: 10,
  //   zIndex: 1000
  // },
 
  logo_image: {
    textDecoration: 'none',
    whiteSpace: "nowrap",
    background: "url(./dg_logo1.png) no-repeat",
    backgroundSize: "40px",
    padding: "20px 0px 20px 0px",
    backgroundPosition: "0 50%",
    color: "#fff",
    display: "block",
    margin: "5px 15px",
    fontSize: "1.2em",
    float:"left",
    width:"40px",
  }

}
));
const toast_options = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3
  }
};
const TheHeaderNew = (props) => {


  const [urlVal, SetUrlVal] = useState("")
  const [isRadiobuttonBox, setIsRadiobuttonBox] = useState(false);
  const slcBoxRef = useRef(null); // Ref for the slc_box
  const gridHeaderRef = useRef(null); // Ref for the slc_box
  const [isGridList, setIsGridList] = useState(false)

  const handleClickOutside = (event) => {
    // Close the box if the clicked target is outside the referenced box
    if (slcBoxRef.current && !slcBoxRef.current.contains(event.target)) {
      setIsRadiobuttonBox(false);
    }
    if (gridHeaderRef.current && !gridHeaderRef.current.contains(event.target)) {
      setIsGridList(false);
    }

    
  };


  const [sliderData, SetSliderData] = useState(["./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png", "./canvas.png"])

  const [counter, setCounter] = useState(0)


  const [Toggle, setToggle] = useState(false)

  const dispatch = useDispatch()
  const classes = useStyles();
  const sidebarShow = useSelector(state => state.sidebarShow)
  const companySelectedVal = useSelector(state => state.companySelectedVal)

  const history = useHistory();
  const url = useSelector((state) => state.url);
  const compId = useSelector((state) => state.companyId);
  const companyList = useSelector((state) => state.companyList);

  const [CompanyDropdown, setCompanyDropdownValue] = useState(compId);
  const [isLoading, setIsLoading] = useState(true); // Initialize loading state

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      // Call your Redux action to fetch company data
      getCompanyData(); 
    } else {
      localStorage.clear();
      history.push("/");
    }
  }, []);

  useEffect(() => {
    // Check if companyList has data, and stop the loader
    if (companyList && companyList.length > 0) {
      setIsLoading(false); // Stop loader when data is available
    }
  }, [companyList]);


  useEffect(() => {
    if (isRadiobuttonBox) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isRadiobuttonBox]);

  useEffect(() => {
    if (isGridList) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isGridList]);
  

  const getCompanyData = () => {


    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem('access_token'),
      // reqFrom: "ADMIN",
    };
    axios({
      method: "GET",
      url: settings.serverUrl + "/getCompaniesData",
      headers,
    }).then((response) => {
      console.log("Response from header company list===", response.data.result);
      if (response.data.err) {
        toast.error(response.data.err, toast_options);
      } else {
        if (response.data.result) {
          dispatch({ type: 'set', companyList: response.data.result })
        }
      }
    }).catch(err => {
      handleApiError(err, history);
      // toast.error(err.message, toast_options);
      // if (err.message.includes("403")) {
      //   localStorage.clear();
      //   history.push("/");
      // }
    });
  }

  console.log("url props::", props)

  const handleCompanyChange = (e) => {
    setCompanyDropdownValue(e.comp_id)
    dispatch({ type: 'set', companyId: e.comp_id, show_ideagen: e.show_ideagen, show_adv_search: e.show_adv_search });
    setIsRadiobuttonBox(false);
    localStorage.setItem('companyId', e.comp_id)
    history.push("/incoming_list");
  }

  const toggleSidebar = () => {
    const val = [true, 'responsive'].includes(sidebarShow) ? false : 'responsive'
    dispatch({ type: 'set', sidebarShow: val })
  }

  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive'
    dispatch({ type: 'set', sidebarShow: val })
  }

  let change = ""
  if (window.location.href.includes("detail")) {
    change = "detail page"
  }

  if (window.location.href.includes("details")) {
    change = "details page"
  }

  if (window.location.href.includes("incoming")) {
    change = "incoming page"
  }
  console.log("change", change)



  const CustomRightArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType }
    } = rest;
    console.log("currentSlide: ", currentSlide);
    console.log("deviceType: ", deviceType);
    setCounter(currentSlide)

    return <button onClick={() => {
      onClick();

    }} className={classes.carousel_arrow_right} ><i class="fa fa-chevron-right" aria-hidden="true"></i></button>;
  };

  const CustomLeftArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType }
    } = rest;
    setCounter(currentSlide)

    return <button onClick={() => {
      onClick();

    }} className={classes.carousel_arrow_left} ><i class="fa fa-chevron-left" aria-hidden="true"></i></button>;
  };
  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const { carouselState: { currentSlide } } = rest;
    return (
      <div className="carousel-button-group" style={{ position: "absolute", zIndex: "1", bottom: "12px", right: "40px" }}>

        <div style={{ color: "#fff", textAlign: "right", marginTop: "15px" }}>Pages
          <CInput type='text'
            value={counter}
            onChange={(e) => {
              goToSlide(e.target.value);
              setCounter(e.target.value)
            }}
            style={{
              background: "none",
              color: "#fff",
              borderRadius: "0",
              margin: "0 7px",
              width: "50px",
              border: "1px solid #fff",
              textAlign: "center",
              display: 'inline-block'
            }}
          /> of {sliderData.length}</div>

      </div>
    );
  };
  const sliderClick = () => {
    setToggle(!Toggle)
  }


  console.log("Toggle", Toggle)
  return (
    <>
      <div className="header_bg">
        
       
          <Link
            to="/incoming_list"
            className={classes.logo_image}>
            
          </Link>
        
<div style={{width:40, float:"right", marginTop:5}}>
              <TheHeaderDropdown />
        
              </div>

      </div>
      <div className='right_bar'>


 

<span onClick={() => setIsRadiobuttonBox(true)}>
<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
  <path d="M22,14c0,.552-.447,1-1,1H9c-.552,0-1-.448-1-1s.448-1,1-1h12c.553,0,1,.448,1,1ZM5,12H3c-.552,0-1,.448-1,1v2c0,.552,.448,1,1,1h2c.552,0,1-.448,1-1v-2c0-.552-.448-1-1-1Zm16,7H9c-.552,0-1,.448-1,1s.448,1,1,1h12c.553,0,1-.448,1-1s-.447-1-1-1Zm-16-1H3c-.552,0-1,.448-1,1v2c0,.552,.448,1,1,1h2c.552,0,1-.448,1-1v-2c0-.552-.448-1-1-1ZM24,4v2c0,2.206-1.794,4-4,4H4C1.794,10,0,8.206,0,6v-2C0,1.794,1.794,0,4,0H20c2.206,0,4,1.794,4,4Zm-2,0c0-1.103-.897-2-2-2H4c-1.103,0-2,.897-2,2v2c0,1.103,.897,2,2,2H20c1.103,0,2-.897,2-2v-2Zm-2.886-.5h-4.257c-.697,0-1.043,.846-.546,1.334l1.858,1.825c.455,.455,1.177,.455,1.632,0l1.858-1.825c.498-.489,.152-1.334-.546-1.334Z"/>
</svg>
</span>
{isRadiobuttonBox && (
<div className='slc_box' ref={slcBoxRef}>
{
  companyList && companyList.length > 0 &&
  <div className="master_radio_buttons">
    <h6>Select Company:</h6>
    <div className='close_radio_bottons' onClick={() => setIsRadiobuttonBox(false)}>
    <i class="fa fa-times" aria-hidden="true"></i>

    </div>
    <div>
      {/* Loader */}
      {isLoading ? (
        <div style={{ marginTop: "10px", color: "blue" }}>Loading...</div>
      ) : (
        /* Render company list when data is ready */
        <div className="company_list">
          {companyList.map((curr, index) => (
            <div key={index} className="radio_option">
              <input
                type="radio"
                id={`company_${curr.comp_id}`}
                name="company"
                value={curr.comp_id}
                checked={CompanyDropdown === curr.comp_id}
                onChange={()=>handleCompanyChange(curr)}
              />
              <label htmlFor={`company_${curr.comp_id}`}>{curr.name}</label>
            </div>
          ))}
        </div>
      )}
    </div>
   
  </div>
}
</div>
)}
{/* <span onClick={() => setIsGridList(true)}><i class="fa fa-th" aria-hidden="true"></i></span> */}

{/* {isGridList && (
<div className="grid_header" style={{ width: localStorage.getItem('master') && JSON.parse(localStorage.getItem('master'))}} ref={gridHeaderRef}>
           
                 
                      {localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
                  
                          <div className="grid_menu" onClick={() => { history.push('/compnies') }}>
           
      <i class="fa fa-building" aria-hidden="true"></i> Companies List

                          </div>
                     
                      }
                   

                        <div className="grid_menu" onClick={() => { history.push('/companyUser') }} style={{ borderTop: "1px solid #ddd", borderBottom: "1px solid #ddd" }}>
                        
                          <i class="fa fa-user" aria-hidden="true"></i> Users List
                     
                        </div>
                 
                      {localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
                 
                          <div className="grid_menu" onClick={() => { history.push('/processors') }}>
                             <i class="fa fa-cogs" aria-hidden="true"></i> Processor List
                          </div>
                      
                      }
               
                  </div>
)} */}
                <Tooltip title="Home" placement="right-start">
                  <div onClick={() => { history.push('/incoming_list') }}>
                    <span><i class="fa fa-home" aria-hidden="true"></i></span>
                  </div>
                </Tooltip>

                {localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
                <Tooltip title="Companies List" placement="right-start">
                  <div onClick={() => { history.push('/compnies') }}>
                    <span><i class="fa fa-building" aria-hidden="true"></i></span>
                  </div>
                 </Tooltip>
                } 

                <Tooltip title="Users List" placement="right-start">
                  <div onClick={() => { history.push('/companyUser') }}>
                    <span><i class="fa fa-user" aria-hidden="true"></i></span>
                  </div>
                </Tooltip>
               
                {localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
                <Tooltip title="Processor List" placement="right-start">
                  <div onClick={() => { history.push('/processors') }}>
                    <span><i class="fa fa-cogs" aria-hidden="true"></i></span>
                  </div>
                </Tooltip>
                }
                {/* <span><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </span>
                <span><i class="fa fa-file-text-o" aria-hidden="true"></i>
                </span>
                <span><i class="fa fa-cloud-upload" aria-hidden="true"></i>
                </span>
                <span><i class="fa fa-th-large" aria-hidden="true"></i>
                </span>
                <span><i class="fa fa-cogs" aria-hidden="true"></i>
                </span> */}
            </div>
     
    </>
  )
}

export default TheHeaderNew
